import { render } from "./historie.vue?vue&type=template&id=42c49234"
import script from "./historie.vue?vue&type=script&lang=js"
export * from "./historie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/testportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__